const features = [
  {
    icon: 'ri-shield-check-line',
    title: 'Military-Grade Security',
    description:
      'All our apps implement AES-256 encryption and follow industry-leading security standards to keep your data safe from any threat.',
    color: 'text-emerald-500',
    bg: 'bg-emerald-50',
  },
  {
    icon: 'ri-speed-line',
    title: 'Optimized Performance',
    description:
      'Built with Swift and native iOS frameworks, our apps run lean and fast — no battery drain, no slowdowns, no compromises.',
    color: 'text-teal-500',
    bg: 'bg-teal-50',
  },
  {
    icon: 'ri-eye-off-line',
    title: 'Zero-Log Privacy',
    description:
      'We never collect, store, or sell your personal data. Our strict no-log policy ensures your activity stays completely private.',
    color: 'text-cyan-500',
    bg: 'bg-cyan-50',
  },
  {
    icon: 'ri-smartphone-line',
    title: 'Native iOS Design',
    description:
      'Every interface is crafted to feel right at home on iOS — following Apple\'s Human Interface Guidelines for a seamless, intuitive experience.',
    color: 'text-emerald-600',
    bg: 'bg-emerald-50',
  },
  {
    icon: 'ri-refresh-line',
    title: 'Regular Updates',
    description:
      'Our dedicated team continuously improves our apps with new features, security patches, and compatibility updates for the latest iOS versions.',
    color: 'text-teal-600',
    bg: 'bg-teal-50',
  },
  {
    icon: 'ri-customer-service-2-line',
    title: 'Dedicated Support',
    description:
      'Our expert support team is always ready to help. We respond quickly and work hard to resolve any issue you encounter.',
    color: 'text-cyan-600',
    bg: 'bg-cyan-50',
  },
];

export default function FeaturesSection() {
  return (
    <section id="features" className="py-24 md:py-32 bg-[#fafaf8]">
      <div className="max-w-6xl mx-auto px-6 md:px-10">
        {/* Header */}
        <div className="flex flex-col lg:flex-row lg:items-end lg:justify-between mb-16 md:mb-20 gap-6">
          <div>
            <p
              className="text-xs uppercase tracking-[0.3em] text-gray-400 font-semibold mb-4"
              style={{ fontFamily: "'Space Grotesk', sans-serif" }}
            >
              Key Features
            </p>
            <h2
              className="text-4xl md:text-5xl font-bold text-gray-900 leading-tight"
              style={{ fontFamily: "'Space Grotesk', sans-serif" }}
            >
              Why Choose
              <br />
              <span className="text-emerald-500">KOREN d.o.o.</span>
            </h2>
          </div>
          <p className="text-gray-500 text-base md:text-lg max-w-sm leading-relaxed">
            Every product we ship is built around these core principles that define who we are.
          </p>
        </div>

        {/* Feature Grid */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 md:gap-8">
          {features.map((feat) => (
            <div
              key={feat.title}
              className="bg-white rounded-2xl p-7 border border-gray-100 group hover:border-emerald-100 transition-colors duration-300"
            >
              <div className={`inline-flex items-center justify-center w-12 h-12 rounded-xl ${feat.bg} mb-5`}>
                <i className={`${feat.icon} text-xl ${feat.color}`} />
              </div>
              <h3
                className="text-lg font-bold text-gray-900 mb-3"
                style={{ fontFamily: "'Space Grotesk', sans-serif" }}
              >
                {feat.title}
              </h3>
              <p className="text-gray-500 text-sm leading-relaxed">{feat.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
